import React from "react";
import {
  BookOpen,
  Compass,
  HelpCircle,
  MessageCircle,
  Bug,
  Lightbulb,
} from "lucide-react";

interface HelpLinkProps {
  icon: React.ReactNode;
  href: string;
  label: string;
  description?: string;
}

const HelpLink: React.FC<HelpLinkProps> = ({
  icon,
  href,
  label,
  description,
}) => (
  <li>
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 px-1 py-1 rounded-md hover:bg-muted transition-colors group"
    >
      <span className="text-muted-foreground group-hover:text-blue-600 dark:group-hover:text-blue-400 flex-shrink-0">
        {icon}
      </span>
      <span className="text-sm text-foreground">
        {label}
        {description && (
          <span className="text-muted-foreground"> — {description}</span>
        )}
      </span>
    </a>
  </li>
);

/**
 * "Need Help?" section rendered as JSX with Lucide icons.
 * Displayed below the markdown help content in the HelpPanel.
 */
const HelpLinks: React.FC = () => (
  <div>
    <ul>
      <HelpLink
        icon={<BookOpen className="h-4 w-4" />}
        href="https://w.amazon.com/bin/view/AWS/WWRO/SEPS/SMIE/TACO/UserGuide"
        label="User guide"
      />
      <HelpLink
        icon={<Compass className="h-4 w-4" />}
        href="https://w.amazon.com/bin/view/AWS/WWRO/SEPS/SMIE/TACO/UseCases"
        label="Use cases"
      />
      <HelpLink
        icon={<HelpCircle className="h-4 w-4" />}
        href="https://w.amazon.com/bin/view/AWS/WWRO/SEPS/SMIE/TACO/FAQ"
        label="FAQs"
      />
      <HelpLink
        icon={<MessageCircle className="h-4 w-4" />}
        href="https://amazon.enterprise.slack.com/archives/C0B1HCUL6QN"
        label="#afx-taco-interest"
        description="Reach out on Slack"
      />
      <HelpLink
        icon={<Bug className="h-4 w-4" />}
        href="https://t.corp.amazon.com/create/templates/d3a5d214-d882-4caf-bc5c-57a62f7f0ba8"
        label="Submit a bug report"
        description="Project ID is copied to the clipboard"
      />
      <HelpLink
        icon={<Lightbulb className="h-4 w-4" />}
        href="https://t.corp.amazon.com/create/templates/6f4f4ad9-221e-4cee-93af-1453eddefd8d"
        label="Submit a feature request"
      />
    </ul>
  </div>
);

export default HelpLinks;
